import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  attributesQueryOptions,
  customizationsQueryOptions,
  ProductTypesPage,
} from '@/features/dictionary';

export const Route = createFileRoute('/_authed/_active/org/catalog-setup/product-types/new')({
  staticData: { crumb: 'productTypes:new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'attributes.write');
  },
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.query({ ...attributesQueryOptions(), staleTime: 'static' }),
      context.queryClient.query({ ...customizationsQueryOptions(), staleTime: 'static' }),
    ]).catch(() => undefined),
  component: () => <ProductTypesPage view="new" />,
});
